/**
 * @copyright   2010-2015, The Titon Project
 * @license     http://opensource.org/licenses/BSD-3-Clause
 * @link        http://titon.io
 */

define([
    'jquery'
], function($) {

/**
 * Bound a number between a min and max range.
 * If the number is greater than or equal to the max, reset to min (or 0).
 * If the number is less than the min, reset to the max - 1.
 *
 * @param {Number} value
 * @param {Number} max
 * @param {Number} [min]
 * @returns {Number}
 */
$.bound = function(value, max, min) {
    min = min || 0;

    if (value >= max) {
        value = min;
    } else if (value < min) {
        value = max - 1;
    }

    return value;
};

});


//////////////////
// WEBPACK FOOTER
// ./node_modules/titon-toolkit/js/extensions/bound.js
// module id = 358
// module chunks = 1